import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class CodeOfConductPoliciesCompliance extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_code_of_conduct_and_policies_compliance');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'non_disclosure_agreement')}><i class="fas fa-file-download"></i> Non-Disclosure Agreement</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'confidentiality_agreement')}><i class="fas fa-file-download"></i> Confidentiality Agreement</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'conflict_of_interest_declaration')}><i class="fas fa-file-download"></i> Conflict of Interest Declaration</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'it_and_cybersecurity_policy_acknowledgment')}><i class="fas fa-file-download"></i> IT &amp; Cybersecurity Policy Acknowledgment</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'hr_policy_and_emp_handbook_ack')}><i class="fas fa-file-download"></i> HR Policy &amp; Employee Handbook Acknowledgment</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'posh_compliance')}><i class="fas fa-file-download"></i> POSH Compliance</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'insider_trading_policy_dec')}><i class="fas fa-file-download"></i> Insider Trading Policy Declaration</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'other_declarations')}><i class="fas fa-file-download"></i> Other declarations</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'employee_code_of_conduct_and_policies_compliance';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_download_employee_files_url.php";
    }else{
      url = "/php/admin_download_employee_files_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#old_non_disclosure_agreement').val(data['non_disclosure_agreement_new_name']);
    $('#old_confidentiality_agreement').val(data['confidentiality_agreement_new_name']);
    $('#old_conflict_of_interest_declaration').val(data['conflict_of_interest_declaration_new_name']);
    $('#old_it_and_cybersecurity_policy_acknowledgment').val(data['it_and_cybersecurity_policy_acknowledgment_new_name']);
    $('#old_hr_policy_and_emp_handbook_ack').val(data['hr_policy_and_emp_handbook_ack_new_name']);
    $('#old_posh_compliance').val(data['posh_compliance_new_name']);
    $('#old_insider_trading_policy_dec').val(data['insider_trading_policy_dec_new_name']);
    $('#old_other_declarations').val(data['other_declarations_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());


    var non_disclosure_agreement_temp    = window.isNullAndUndef($('#non_disclosure_agreement').val());
    var org_non_disclosure_agreement     = $("#non_disclosure_agreement").prop("files")[0];
    var non_disclosure_agreement_name    = $('#non_disclosure_agreement').val().split('\\').pop();

    var confidentiality_agreement_temp        = window.isNullAndUndef($('#confidentiality_agreement').val());
    var org_confidentiality_agreement         = $("#confidentiality_agreement").prop("files")[0];
    var confidentiality_agreement_name        = $('#confidentiality_agreement').val().split('\\').pop();

    var conflict_of_interest_declaration_temp        = window.isNullAndUndef($('#conflict_of_interest_declaration').val());
    var org_conflict_of_interest_declaration         = $("#conflict_of_interest_declaration").prop("files")[0];
    var conflict_of_interest_declaration_name        = $('#conflict_of_interest_declaration').val().split('\\').pop();

    var it_and_cybersecurity_policy_acknowledgment_temp        = window.isNullAndUndef($('#it_and_cybersecurity_policy_acknowledgment').val());
    var org_it_and_cybersecurity_policy_acknowledgment         = $("#it_and_cybersecurity_policy_acknowledgment").prop("files")[0];
    var it_and_cybersecurity_policy_acknowledgment_name        = $('#it_and_cybersecurity_policy_acknowledgment').val().split('\\').pop();

    var hr_policy_and_emp_handbook_ack_temp        = window.isNullAndUndef($('#hr_policy_and_emp_handbook_ack').val());
    var org_hr_policy_and_emp_handbook_ack         = $("#hr_policy_and_emp_handbook_ack").prop("files")[0];
    var hr_policy_and_emp_handbook_ack_name        = $('#hr_policy_and_emp_handbook_ack').val().split('\\').pop();

    var posh_compliance_temp        = window.isNullAndUndef($('#posh_compliance').val());
    var org_posh_compliance         = $("#posh_compliance").prop("files")[0];
    var posh_compliance_name        = $('#posh_compliance').val().split('\\').pop();

    var insider_trading_policy_dec_temp        = window.isNullAndUndef($('#insider_trading_policy_dec').val());
    var org_insider_trading_policy_dec         = $("#insider_trading_policy_dec").prop("files")[0];
    var insider_trading_policy_dec_name        = $('#insider_trading_policy_dec').val().split('\\').pop();

    var other_declarations_temp        = window.isNullAndUndef($('#other_declarations').val());
    var org_other_declarations         = $("#other_declarations").prop("files")[0];
    var other_declarations_name        = $('#other_declarations').val().split('\\').pop();


    var non_disclosure_agreement_ext          = '';
    var confidentiality_agreement_ext         = '';
    var conflict_of_interest_declaration_ext  = '';
    var it_and_cybersecurity_policy_acknowledgment_ext  = '';
    var hr_policy_and_emp_handbook_ack_ext  = '';
    var posh_compliance_ext  = '';
    var insider_trading_policy_dec_ext  = '';
    var other_declarations_ext  = '';

    if(non_disclosure_agreement_temp && confidentiality_agreement_temp && conflict_of_interest_declaration_temp && it_and_cybersecurity_policy_acknowledgment_temp && hr_policy_and_emp_handbook_ack_temp && posh_compliance_temp && insider_trading_policy_dec_temp && other_declarations_temp){
      non_disclosure_agreement_ext                          = non_disclosure_agreement_temp.split('.').pop();
      confidentiality_agreement_ext                         = confidentiality_agreement_temp.split('.').pop();
      conflict_of_interest_declaration_ext                  = conflict_of_interest_declaration_temp.split('.').pop();
      it_and_cybersecurity_policy_acknowledgment_ext        = it_and_cybersecurity_policy_acknowledgment_temp.split('.').pop();
      hr_policy_and_emp_handbook_ack_ext                    = hr_policy_and_emp_handbook_ack_temp.split('.').pop();
      posh_compliance_ext                                   = posh_compliance_temp.split('.').pop();
      insider_trading_policy_dec_ext                        = insider_trading_policy_dec_temp.split('.').pop();
      other_declarations_ext                                = other_declarations_temp.split('.').pop();
    }

    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(file_main_ext.indexOf(non_disclosure_agreement_ext) >= 0 && file_main_ext.indexOf(confidentiality_agreement_ext) >= 0 && file_main_ext.indexOf(conflict_of_interest_declaration_ext) >= 0 && file_main_ext.indexOf(it_and_cybersecurity_policy_acknowledgment_ext) >= 0 && file_main_ext.indexOf(hr_policy_and_emp_handbook_ack_ext) >= 0 && file_main_ext.indexOf(posh_compliance_ext) >= 0 && file_main_ext.indexOf(other_declarations_ext) >= 0 && file_main_ext.indexOf(insider_trading_policy_dec_ext) >= 0){
      var old_non_disclosure_agreement                        = $('#old_non_disclosure_agreement').val();
      var old_confidentiality_agreement                       = $('#old_confidentiality_agreement').val();
      var old_conflict_of_interest_declaration                = $('#old_conflict_of_interest_declaration').val();
      var old_it_and_cybersecurity_policy_acknowledgment      = $('#old_it_and_cybersecurity_policy_acknowledgment').val();
      var old_hr_policy_and_emp_handbook_ack                  = $('#old_hr_policy_and_emp_handbook_ack').val();
      var old_posh_compliance                                 = $('#old_posh_compliance').val();
      var old_insider_trading_policy_dec                      = $('#old_insider_trading_policy_dec').val();
      var old_other_declarations                              = $('#old_other_declarations').val();
      var all_data                                            = {};

      all_data['non_disclosure_agreement']                    = window.return_false_null(non_disclosure_agreement_name);
      all_data['confidentiality_agreement']                   = window.return_false_null(confidentiality_agreement_name);
      all_data['conflict_of_interest_declaration']            = window.return_false_null(conflict_of_interest_declaration_name);
      all_data['it_and_cybersecurity_policy_acknowledgment']  = window.return_false_null(it_and_cybersecurity_policy_acknowledgment_name);
      all_data['hr_policy_and_emp_handbook_ack']              = window.return_false_null(hr_policy_and_emp_handbook_ack_name);
      all_data['posh_compliance']                             = window.return_false_null(posh_compliance_name);
      all_data['insider_trading_policy_dec']                  = window.return_false_null(insider_trading_policy_dec_name);
      all_data['other_declarations']                          = window.return_false_null(other_declarations_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('non_disclosure_agreement',org_non_disclosure_agreement);
      body.append('old_non_disclosure_agreement',old_non_disclosure_agreement);
      body.append('confidentiality_agreement',org_confidentiality_agreement);
      body.append('old_confidentiality_agreement',old_confidentiality_agreement);
      body.append('conflict_of_interest_declaration',org_conflict_of_interest_declaration);
      body.append('old_conflict_of_interest_declaration',old_conflict_of_interest_declaration);
      body.append('it_and_cybersecurity_policy_acknowledgment',org_it_and_cybersecurity_policy_acknowledgment);
      body.append('old_it_and_cybersecurity_policy_acknowledgment',old_it_and_cybersecurity_policy_acknowledgment);
      body.append('hr_policy_and_emp_handbook_ack',org_hr_policy_and_emp_handbook_ack);
      body.append('old_hr_policy_and_emp_handbook_ack',old_hr_policy_and_emp_handbook_ack);
      body.append('posh_compliance',org_posh_compliance);
      body.append('old_posh_compliance',old_posh_compliance);
      body.append('insider_trading_policy_dec',org_insider_trading_policy_dec);
      body.append('old_insider_trading_policy_dec',old_insider_trading_policy_dec);
      body.append('other_declarations',org_other_declarations);
      body.append('old_other_declarations',old_other_declarations);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_code_of_conduct_and_policies_compliance');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('non_disclosure_agreement','confidentiality_agreement','conflict_of_interest_declaration','it_and_cybersecurity_policy_acknowledgment','hr_policy_and_emp_handbook_ack','posh_compliance','insider_trading_policy_dec','other_declarations');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_non_disclosure_agreement" placeholder=""/>
                                        <input type="file" className="form-control" id="non_disclosure_agreement" placeholder="Non-Disclosure Agreement (NDA)"/>
                                        <label for="name">Non-Disclosure Agreement (NDA)</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_confidentiality_agreement" placeholder=""/>
                                        <input type="file" className="form-control" id="confidentiality_agreement" placeholder="Confidentiality Agreement"/>
                                        <label for="name">Confidentiality Agreement</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_conflict_of_interest_declaration" placeholder=""/>
                                        <input type="file" className="form-control" id="conflict_of_interest_declaration" placeholder="Conflict of Interest Declaration"/>
                                        <label for="name">Conflict of Interest Declaration</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_it_and_cybersecurity_policy_acknowledgment" placeholder=""/>
                                        <input type="file" className="form-control" id="it_and_cybersecurity_policy_acknowledgment" placeholder="IT &amp; Cybersecurity Policy Acknowledgment"/>
                                        <label for="name">IT &amp; Cybersecurity Policy Acknowledgment</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_hr_policy_and_emp_handbook_ack" placeholder=""/>
                                        <input type="file" className="form-control" id="hr_policy_and_emp_handbook_ack" placeholder="HR Policy &amp; Employee Handbook Acknowledgment"/>
                                        <label for="name">HR Policy &amp; Employee Handbook Acknowledgment</label>
                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_posh_compliance" placeholder=""/>
                                        <input type="file" className="form-control" id="posh_compliance" placeholder="POSH (Prevention of Sexual Harassment) Compliance"/>
                                        <label for="name">POSH (Prevention of Sexual Harassment) Compliance</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_insider_trading_policy_dec" placeholder=""/>
                                        <input type="file" className="form-control" id="insider_trading_policy_dec" placeholder="Insider Trading Policy Declaration"/>
                                        <label for="name">Insider Trading Policy Declaration</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_other_declarations" placeholder=""/>
                                        <input type="file" className="form-control" id="other_declarations" placeholder="Other declarations"/>
                                        <label for="name">Other declarations</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default CodeOfConductPoliciesCompliance;
